// import React from 'react';
// import { Container, Row, Col } from 'react-bootstrap'; // Import necessary components from Bootstrap

// const Pricing = () => {
//   const carData = [
//     {
//       id: 1,
//       name: "Swift Dzire",
//       city: "Chicago",
//       image: "/images/ourfleet/1.jpg",
//       seater: "4+1",
//       driverAllowance: "₹300",
//       perKm: "₹12",
      
//     },
//     {
//       id: 2,
//       name: "Honda City",
//       city: "Chicago",
//       image: "/images/ourfleet/2.jpg",
//       seater: "4+1",
//       driverAllowance: "₹300",
//       perKm: "₹12",
      
//     },
//     {
//       id: 3,
//       name: "Nexa Ciaz",
//       city: "Chicago",
//       image: "/images/ourfleet/4.jpg",
//       seater: "4+1",
//       driverAllowance: "₹300",
//       perKm: "₹12",
      
//     },
//     {
//       id: 4,
//       name: "Ertiga",
//       city: "Chicago",
//       image: "/images/ourfleet/3.jpg",
//       seater: "6+1",
//       driverAllowance: "₹300",
//       perKm: "₹14",
      
//     },
//     {
//       id: 5,
//       name: "Innova",
//       city: "Chicago",
//       image: "/images/ourfleet/5.jpg",
//       seater: "6+1",
//       driverAllowance: "₹300",
//       perKm: "₹17",
      
//     },
//     {
//       id: 6,
//       name: "Innova Crysta",
//       city: "Chicago",
//       image: "/images/ourfleet/6.jpg",
//       seater: "7+1",
//       driverAllowance: "₹300",
//       perKm: "₹19",
      
//     },
//     {
//       id: 7,
//       name: "Fortuner",
//       city: "Chicago",
//       image: "/images/ourfleet/7.jpg",
//       seater: "7+1",
//       driverAllowance: "-",
//       perKm: "-",
      
//     },
//     {
//       id: 8,
//       name: "Audi",
//       city: "Chicago",
//       image: "/images/ourfleet/8.jpg",
//       seater: "4+1",
//       driverAllowance: "-",
//       perKm: "-",
//       extraHr: "-",
//       nightHalt: "-",
//     },
//     {
//       id: 9,
//       name: "BMW",
//       city: "Chicago",
//       image: "/images/ourfleet/9.jpg",
//       seater: "4+1",
//       driverAllowance: "-",
//       perKm: "-",
//       extraHr: "-",
//       nightHalt: "-",
//     },
//     {
//       id: 10,
//       name: "Jaguar",
//       namee: "Jaguar",
//       city: "Chicago",
//       image: "/images/ourfleet/10.jpg",
//       seater: "4+1",
//       driverAllowance: "-",
//       perKm: "-",
//       extraHr: "-",
//       nightHalt: "-",
//     },
//     {
//       id: 11,
//       name: "Tata Winger",
//       namee: "Tata Winger",
//       city: "Chicago",
//       image: "/images/ourfleet/11.jpg",
//       seater: "13/17",
//       driverAllowance: "-",
//       perKm: "-",
      
//     },
//     {
//       id: 12,
//       name: "13 Seater Tempo Traveller",
//       city: "Chicago",
//       image: "/images/ourfleet/12.jpg",
//       seater: "13",
//       driverAllowance: "-",
//       perKm: "-",
      
//     },
//     {
//       id: 13,
//       name: "17 Seater Tempo Traveller",
//       city: "Chicago",
//       image: "/images/ourfleet/13.jpg",
//       seater: "17",
//       driverAllowance: "-",
//       perKm: "-",
      
//     },
//     {
//       id: 14,
//       name: "20 Seater Tempo Traveller",
//       city: "Chicago",
//       image: "/images/ourfleet/14.jpg",
//       seater: "20",
//       driverAllowance: "-",
//       perKm: "-",
      
//     },
//     {
//       id: 15,
//       name: "Luxury Bus",
//       namee: "Luxury Bus",
//       city: "Chicago",
//       image: "/images/ourfleet/15.jpg",
//       seater: "32",
//       driverAllowance: "-",
//       perKm: "-",
      
//     },
//   ];

//   // Generate the WhatsApp link dynamically based on vehicle name
//   const generateWhatsAppLink = (carName) => {
//     const message = `Hello SHREE Tours & Travels Team, I would like to book the ${carName}. Please let me know the details.`;
//     const encodedMessage = encodeURIComponent(message);
//     return `https://wa.me/+919594917913?text=${encodedMessage}`;
//   };

//   return (
//     <>
//       <section
//         className="page-title"
//         style={{ backgroundImage: 'url(images/hero.jpg)' }}
//       >
//         <div className="auto-container">
//           <div className="title-outer text-center">
//             <h1 className="title">Booking</h1>
//           </div>
//         </div>
//       </section>

//       <section className="pricing-section">
//         <div className="auto-container">
//           <div className="bg bg-pattern-5"></div>
//           <div className="outer-box" data-aos="fade-left">
//             <Container>
//               <Row>
//                 {carData.map((car) => (
//                   <Col md={4} sm={12} key={car.id}>
//                     <div className="pricing-block">
//                       <div className="inner-box">
//                         <div className="image-box">
//                           <figure className="image">
//                             <img src={car.image} alt={car.name} />
//                           </figure>
//                         </div>
//                         <div className="content ">
//                           <div className="car-detail  text-center">
//                             <h4 className="car-name text-white text-center ">{car.name}</h4>
//                             <p className='' style={{color:'#0310A8'}}>{car.namee}</p>
//                           </div>
//                           <ul className="feature-list border">
//                             <li className='fs-5'>Seater: <span className="price">{car.seater}</span></li>
//                             <li className='fs-5'>Driver Allowance: <span className="price">{car.driverAllowance}</span></li>
//                             <li className='fs-5'>Per Km: <span className="price">{car.perKm}</span></li>
                        
//                           </ul>
//                           <div className="btn-box">
//                             {car.name === 'BMW' || car.name === 'Audi' || car.name === 'Jaguar' ? (
                              
//                               <a href={generateWhatsAppLink(car.name)} target='_blank' className="theme-btn btn-style-two hover-light">
//                                 <span className="btn-title">Enquire & Book</span>
//                               </a>
//                             ) : (
//                               // Render "Book Your Cab" button for other vehicles
//                               <a href={generateWhatsAppLink(car.name)} target='_blank' className="theme-btn btn-style-two hover-light">
//                                 <span className="btn-title">Book Your Cab</span>
//                               </a>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </Col>
//                 ))}
//               </Row>
//             </Container>
//           </div>
//         </div>
//       </section>



      
//       <div className="rules-guidelines container pt-0 pb-5">
//   <h2 style={{fontFamily :'Lucida Calligraphy'}}>Rules and Guidelines :</h2>
//   <ul className="rules-list text-dark">
//     <li>• Driver Allowance will charge extra.</li>
//     <li>• Extra charges will apply for extra km and hours. Government taxes will be charged as per government rules.</li>
//     <li>• Time and km will be calculated from our office to office.</li>
//     <li>• The charges quoted above are calculated based on the current fuel prices. Any hike in fuel prices will result in a variation in rates.</li>
//     <li>• Interstate taxes, toll taxes, parking and service tax are charged as actuals.</li>
//     <li>• Cab running km is limited to 300 km per day.</li>
//     <li>• Time starts from 6:00 AM to 12:00 PM and the Cab must be free at 12:00 PM. After 12:00 PM, extra charges apply. Night charges apply from 12:00 AM to &nbsp;6:00 AM.</li>
   
//   </ul>
// </div>



//     </>
//   );
// };

// export default Pricing;









import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'; // Import necessary components from Bootstrap
import GoogleAnalytics from '../components/GoogleAnalytics';

const Pricing = () => {
  const carData = [
    {
      id: 1,
      name: "Swift Dzire",
      city: "Chicago",
      image: "/images/ourfleet/1.jpg",
      seater: "4+1",
      driverAllowance: "₹300",
      perKm: "₹12",
    },
    {
      id: 2,
      name: "Honda City",
      city: "Chicago",
      image: "/images/ourfleet/2.jpg",
      seater: "4+1",
      driverAllowance: "₹300",
      perKm: "₹12",
    },
    {
      id: 3,
      name: "Nexa Ciaz",
      city: "Chicago",
      image: "/images/ourfleet/4.jpg",
      seater: "4+1",
      driverAllowance: "₹300",
      perKm: "₹12",
    },
    {
      id: 4,
      name: "Ertiga",
      city: "Chicago",
      image: "/images/ourfleet/3.jpg",
      seater: "6+1",
      driverAllowance: "₹300",
      perKm: "₹14",
    },
    {
      id: 5,
      name: "Innova",
      city: "Chicago",
      image: "/images/ourfleet/5.jpg",
      seater: "6+1",
      driverAllowance: "₹300",
      perKm: "₹17",
    },
    {
      id: 6,
      name: "Innova Crysta",
      city: "Chicago",
      image: "/images/ourfleet/6.jpg",
      seater: "7+1",
      driverAllowance: "₹300",
      perKm: "₹19",
    },
    {
      id: 7,
      name: "Fortuner",
      city: "Chicago",
      image: "/images/ourfleet/7.jpg",
      seater: "7+1",
      driverAllowance: "-",
      perKm: "-",
    },
    {
      id: 8,
      name: "Audi",
      city: "Chicago",
      image: "/images/ourfleet/8.jpg",
      seater: "4+1",
      driverAllowance: "-",
      perKm: "-",
      extraHr: "-",
      nightHalt: "-",
    },
    {
      id: 9,
      name: "BMW",
      city: "Chicago",
      image: "/images/ourfleet/9.jpg",
      seater: "4+1",
      driverAllowance: "-",
      perKm: "-",
      extraHr: "-",
      nightHalt: "-",
    },
    {
      id: 10,
      name: "Jaguar",
      namee: "Jaguar",
      city: "Chicago",
      image: "/images/ourfleet/10.jpg",
      seater: "4+1",
      driverAllowance: "-",
      perKm: "-",
      extraHr: "-",
      nightHalt: "-",
    },
    {
      id: 11,
      name: "Tata Winger",
      namee: "Tata Winger",
      city: "Chicago",
      image: "/images/ourfleet/11.jpg",
      seater: "13/17",
      driverAllowance: "-",
      perKm: "-",
    },
    {
      id: 12,
      name: "13 Seater Tempo Traveller",
      city: "Chicago",
      image: "/images/ourfleet/12.jpg",
      seater: "13",
      driverAllowance: "-",
      perKm: "-",
    },
    {
      id: 13,
      name: "17 Seater Tempo Traveller",
      city: "Chicago",
      image: "/images/ourfleet/13.jpg",
      seater: "17",
      driverAllowance: "-",
      perKm: "-",
    },
    {
      id: 14,
      name: "20 Seater Tempo Traveller",
      city: "Chicago",
      image: "/images/ourfleet/14.jpg",
      seater: "20",
      driverAllowance: "-",
      perKm: "-",
    },
    {
      id: 15,
      name: "Luxury Bus",
      namee: "Luxury Bus",
      city: "Chicago",
      image: "/images/ourfleet/15.jpg",
      seater: "32",
      driverAllowance: "-",
      perKm: "-",
    },
  ];

  // Generate the WhatsApp link dynamically based on vehicle name
  const generateWhatsAppLink = (carName) => {
    const message = `Hello SHREE Tours & Travels Team, I would like to book the ${carName}. Please let me know the details.`;
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/919594917913?text=${encodedMessage}`;
  };

  return (
    <>
    <GoogleAnalytics/>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero2.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">Booking</h1>
          </div>
        </div>
      </section>

      <section className="pricing-section">
        <div className="auto-container">
          <div className="bg bg-pattern-5"></div>
          <div className="outer-box" data-aos="fade-left">
            <Container>
              <Row>
                {carData.map((car, index) => (
                  <Col md={4} sm={12} key={car.id}>
                    <div className="pricing-block">
                      <div className="inner-box">
                        <div className="image-box">
                          <figure className="image">
                            <img src={car.image} alt={car.name} />
                          </figure>
                        </div>
                        <div className="content">
                          <div className="car-detail text-center">
                            <h4 className="car-name text-white text-center">
                              {car.name}
                            </h4>
                            <p className="" style={{ color: '#0310A8' }}>
                              {car.namee}
                            </p>
                          </div>
                          <ul className="feature-list border">
                            <li className="fs-5">
                              Seater: <span className="price">{car.seater}</span>
                            </li>
                            <li className="fs-5">
                              Driver Allowance:{' '}
                              <span className="price">{car.driverAllowance}</span>
                            </li>
                            <li className="fs-5">
                              Per Km: <span className="price">{car.perKm}</span>
                            </li>
                          </ul>
                          <div className="btn-box">
                            {index >= carData.findIndex((car) => car.name === 'Innova Crysta') ? (
                              <a
                                href={generateWhatsAppLink(car.name)}
                                target="_blank"
                                className="theme-btn btn-style-two hover-light"
                              >
                                <span className="btn-title">Enquire & Book</span>
                              </a>
                            ) : (
                              <a
                                href={generateWhatsAppLink(car.name)}
                                target="_blank"
                                className="theme-btn btn-style-two hover-light"
                              >
                                <span className="btn-title">Book Your Cab</span>
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Container>
          </div>
        </div>
      </section>

      <div className="rules-guidelines container pt-0 pb-5">
        <h2 style={{ fontFamily: 'Lucida Calligraphy' }}>Rules and Guidelines :</h2>
        <ul className="rules-list text-dark">
          <li>• Driver Allowance will charge extra.</li>
          <li>
            • Extra charges will apply for extra km and hours. Government taxes will
            be charged as per government rules.
          </li>
          <li>• Time and km will be calculated from our office to office.</li>
          <li>
            • The charges quoted above are calculated based on the current fuel prices.
            Any hike in fuel prices will result in a variation in rates.
          </li>
          <li>• Interstate taxes, toll taxes, parking and service tax are charged as actuals.</li>
          <li>• Cab running km is limited to 300 km per day.</li>
          <li>
            • Time starts from 6:00 AM to 12:00 PM and the Cab must be free at 12:00 PM.
            After 12:00 PM, extra charges apply. Night charges apply from 12:00 AM to &nbsp;6:00 AM.
          </li>
        </ul>
      </div>
    </>
  );
};

export default Pricing;
